import fetch from "@/helpers/fetch";
import params from "@/lib/params";

// 获取列表
export function getQueueIndex(content) {
  return fetch.getFast("/api/queue/index", content);
}

//新增修改队列
export function editQueue(content) {
  return fetch.post("/api/queue/add", null, {
    body: params(content),
  });
}
//队列后端分配架构列表
export function getBackEndDepList(content) {
  return fetch.getFast("/api/queue/backend-dep-list", content);
}

//队列权重比例设定
export function setWeightSet(content) {
  return fetch.post("/api/queue/allocation-weight-set", null, {
    body: params(content),
  });
}

//队列后端分配用户表
export function getBackEndUserList(content) {
  return fetch.getFast("/api/queue/backend-users", content);
}

//队列获取当前组剩余量
export function getBackEndGroupLave(content) {
  return fetch.getFast("/api/queue/backend-group-lave", content);
}

//队列员工分配次数设定
export function seAllocationtTimes(content) {
  return fetch.post("/api/queue/backend-allocation-times-set", null, {
    body: params(content),
  });
}

//队列获取员工姓名
export function getDepUser(content) {
  return fetch.getFast("/api/queue/get-user-name", content);
}

//队列设置模式
export function editMode(content) {
  return fetch.post("/api/queue/set-pattern", null, {
    body: params(content),
  });
}
//名单数量目标模式
export function queueListName(content) {
  return fetch.getFast("/api/queue/list-name", content);
}
//名单数量目标模式-删除员工
export function listNameDel(content) {
  return fetch.getFast("/api/queue/list-name-del", content);
}

// 名单数量目标模式-计划数、是否开启分配状态修改
export function listNameModify(content) {
  return fetch.postFast("/api/queue/list-name-modify", null, {
    body: params(content),
  });
}
// 名单数量目标模式-计划数、是否开启分配状态修改
export function listNameAdd(content) {
  return fetch.postFast("/api/queue/list-name-add", null, {
    body: params(content),
  });
}

//直播室分配配置直播室列表, 参数center必传
export function getRoomLists(content) {
  return fetch.getFast("/api/config/room-lists", content);
}

// 关闭/启用直播室队列分配设置
export function setLiveRoomAllocationSet(content) {
  return fetch.getFast("/api/queue/live-room-allocation-set", content);
}

// 删除队列直播室分配设置
export function delLiveRoomAllocation(content) {
  return fetch.getFast("/api/queue/live-room-allocation-del", content);
}
// 新增或编辑队列直播室分配设置
export function updateLiveRoomAllocation(content) {
  return fetch.postFast("/api/queue/live-room-allocation-add-or-edit", null, {
    body: params(content),
  });
}
